import { TaskService } from './../../../pages/task/task.service';
import { Dependency, ProjectService, ProjectToProjectTask, Resource, ResourceAssignment } from './../../../pages/general/project.service';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Task } from 'src/app/pages/task/task.service';
import { NotificationService } from 'src/app/services/notification.service';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';
import { AuthService } from 'src/app/services';
import { Location } from '@angular/common';
import { TaskPopupComponent } from 'src/app/pages/task/task-popup/task-popup.component';
import { DxGanttComponent } from 'devextreme-angular';

@Component({
    selector: 'app-project-gantt-view',
    templateUrl: './project-gantt-view.component.html',
    styleUrls: ['./project-gantt-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProjectGanttViewComponent implements OnInit {

	public reload: boolean = true;

	private _reload() {
		setTimeout(() => this.reload = false);
		setTimeout(() => this.reload = true);
	}

	public reloadTaskPopupValue: boolean = true;

	public reloadTaskPopup() {
			setTimeout(() => this.reloadTaskPopupValue = false);
			setTimeout(() => this.reloadTaskPopupValue = true);
	}

	@Input() public visible: boolean = true;

	@Input() public selectedProjectId: number = null;

	public tasks: Task[];
	public tasksInitialized: boolean;
	// public tasksNameIdCollection: { id: number, name: string }[];

	public dependencies: Dependency[];
	public resources: Resource[];
	public resourceAssignments: ResourceAssignment[];

	@Input() public users: string[];
	@Output() public usersChange: EventEmitter<string[]> = new EventEmitter<string[]>();

	@Input() public projectsToTasks: ProjectToProjectTask[];
	@Output() public projectsToTasksChange: EventEmitter<ProjectToProjectTask[]> = new EventEmitter<ProjectToProjectTask[]>();

	public showTaskPopup: boolean;

	@ViewChild('gantt', { static: false }) ganttComponent: DxGanttComponent;
	@ViewChild('taskPopup', { static: false }) taskPopupComponent: TaskPopupComponent;

	public currentlySelectedTask: Task = new Task();

	public currentPopUpTaskHasChildren: boolean;

	private hasChildren(task: Task): boolean {
		for (let a = 0; a < this.tasks.length; a++) {
			const element = this.tasks[a];

			if (element.parentTaskId && element.parentTaskId === task.taskId) {
				return true;
			}
		}

		return false;
	}

	public onTaskClick(event: any) {


		this.currentlySelectedTask = this.tasks.find(task => task.taskId === event.key);




	}

	public onTaskDblClick(event: any) {
		console.log("onTaskDblClick - event:", event);

		event.cancel = true;

		let task: Task = event.data as Task;

		this.currentPopUpTaskHasChildren = this.hasChildren(task);
		this.showTaskPopup = true;
		this.taskPopupComponent.setDefaultValuesIfNone();
	}

	private assignResourceToTask(task: any) {


		let resourceAssignment: ResourceAssignment = new ResourceAssignment();

		if (Number.isNaN(Number(task.taskId))) {
			resourceAssignment.id = task.newIdToReplaceAutogeneratedGUID;

		} else {
			resourceAssignment.id = task.taskId;
		}

		resourceAssignment.taskId = task.taskId;

		let resource: Resource = this.resources.find(resource => resource.text === task.responsibleUser);

		if (resource) {
			resourceAssignment.resourceId = resource.id;

			this.resourceAssignments.push(resourceAssignment);
		}
		// else {
		// 	console.error("Coulnd't find resource that would match user responsible for this task.");
		// }


	}

	private assignResourcesToTasks(tasks: Task[]) {
		this.resourceAssignments = [];

		for (let a = 0; a < tasks.length; a++) {
			const task = tasks[a];

			this.assignResourceToTask(task);
		}

		console.log("assignResourcesToTasks - tasks:", tasks, "\nresourceAssignments:", this.resourceAssignments);
	}

	private updateResourceAssignmentOfTask(task: Task) {
		console.log("updateResourceAssignmentOfTask - task:", task, "\nthis.resourceAssignments:", this.resourceAssignments);

		let resourceAssignment: ResourceAssignment = this.resourceAssignments.find(innerResourceAssignment => innerResourceAssignment.taskId === task.taskId);

		if (resourceAssignment) {
			resourceAssignment.resourceId = this.resources.find(resource => resource.text === task.responsibleUser).id;
		}
	}

	public directionItems: { name: string, value: number }[] = [
		{
			name: "Ascending",
			value: 1
		},
		{
			name: "Descending",
			value: -1
		}
	];
	public selectedDirectionItem: { name: string, value: number } = this.directionItems[0];

	public onDirectionItemChanged(event: any) {
		console.log("onDirectionItemChanged - event:", event);

		this.refreshGanttChart();
	}

	public sortingItems: { name: string, sortRule: (a: Task, b: Task, directionValue: number) => number }[] = [
		{
			name: "Subject",
			sortRule: (a: Task, b: Task, directionValue: number) => {
				return ('' + a.taskName).localeCompare(b.taskName) * directionValue;
			}
		},
		{
			name: "Start Date",
			sortRule: (a: Task, b: Task, directionValue: number) => {
				if (a.startDate > b.startDate) return 1 * directionValue;
				if (a.startDate < b.startDate) return -1 * directionValue;

				return 0;
			}
		},
		{
			name: "End Date",
			sortRule: (a: Task, b: Task, directionValue: number) => {
				if (a.deadlineDate > b.deadlineDate) return 1 * directionValue;
				if (a.deadlineDate < b.deadlineDate) return -1 * directionValue;

				return 0;
			}
		},
		{
			name: "Progress",
			sortRule: (a: Task, b: Task, directionValue: number) => {
				return (a.progress - b.progress) * directionValue;
			}
		},
	];
	public selectedSortingItem: { name: string, sortRule: (a: Task, b: Task, directionValue: number) => number } = this.sortingItems[0];

	public onSortingItemChanged(event: any) {
		console.log("onSortingItemChanged - event:", event);

		this.refreshGanttChart();
	}

	public refreshGanttChart() {
		if (this.selectedProjectId) { // If task changes project.
			this.tasks = this.tasks.filter(
				innerTask => {
					return innerTask.projectId === this.selectedProjectId;
				}
			);


		} else {
			//? Force gantt chart update to reflect these changes of the task.
			if (this.tasks.length > 2) { // 2 - is a magic number after which gantt starts acting normally with css.
				this.tasks = [...this.tasks]; //?! This update looks nicer, but if it creates too much garbage stick with `instance.repaint`.
			} else {
				this.ganttComponent.instance.repaint();
			}
		}

		this.tasks.sort((a, b) => this.selectedSortingItem.sortRule(a, b, this.selectedDirectionItem.value));
	}



	public initializeUserList(): void {
		const $this = this;

		this.taskService.getUserList().subscribe(
			userNames => {
				$this.users = userNames;

				$this.resources = [new Resource(0, "Not Assigned")];

				for (let a = 0; a < userNames.length; a++) {
					const userName = userNames[a];

					let resource: Resource = new Resource();

					resource.id = a + 1;
					resource.text = userName;

					$this.resources.push(resource);
				}

				$this.assignResourcesToTasks($this.tasks);

				$this.tasksInitialized = true;
			}
		);
	}

	public loadGanttData(projectId: number) {


		const $this = this;

		this.projectService.getDependencies().subscribe(res => {
			$this.dependencies = $this.projectService.convertProjectTaskDependenciesToDependencies(res);
		});

		if (!projectId) {
			const url = `general/project-deep-dive`;
			$this.location.replaceState(url);

			this.tasksInitialized = false;
			this.projectService.getTasks().subscribe(
				(response) => {
					console.log("loadGanttData -> getTasks - response:", response);

					$this.tasks = response;

					$this.tasks.sort((a, b) => $this.selectedSortingItem.sortRule(a, b, $this.selectedDirectionItem.value));



					$this.initializeUserList();
				}
			);
		} else {
			this.projectService.getProjectToTaskRelations().subscribe(
				(getProjectToTaskRelationsResponse) => {
					console.log("loadGanttData -> getProjectToTaskRelations - response:", getProjectToTaskRelationsResponse);

					$this.projectsToTasks = getProjectToTaskRelationsResponse;

					let currentProjectToTasks = $this.projectsToTasks.filter(x => x.projectId === projectId);

					$this.tasksInitialized = false;
					$this.projectService.getTasks().subscribe(
						(getTasksResponse) => {
							console.log("loadGanttData -> getTasks - response:", getTasksResponse);

							$this.tasks = getTasksResponse.filter(
								innerTasks => {
									return currentProjectToTasks.some(projectToTask => projectToTask.projectTaskId === innerTasks.taskId);
								}
							);

							$this.tasks.sort((a, b) => $this.selectedSortingItem.sortRule(a, b, $this.selectedDirectionItem.value));



							$this.initializeUserList();
						}
					);
				}
			);
		}
	}

	public onDependencyDeleted(event: any) {
		console.log("onDependencyDeleted", event);

		let dependency = event.values as Dependency;

		if (Number.isNaN(Number(dependency.id))) {
			dependency.id = -1;
		}

		if (Number.isNaN(Number(dependency.predecessorId))) {
			let task = this.tasks.find(task => task.taskId === dependency.predecessorId);

			if (task) {
				dependency.predecessorId = task.newIdToReplaceAutogeneratedGUID;
			} else {
				console.error("Couldn't find newly created task with such GUID.");
			}
		}

		if (Number.isNaN(Number(dependency.successorId))) {
			let task = this.tasks.find(task => task.taskId === dependency.successorId);

			if (task) {
				dependency.successorId = task.newIdToReplaceAutogeneratedGUID;
			} else {
				console.error("Couldn't find newly created task with such GUID.");
			}
		}

		console.log("dependency:", dependency, Number.isNaN(dependency.id));

		const $this = this;

		this.projectService.deleteDependency(dependency).subscribe();
	}

	public onDependencyInserted(event: any) {
		console.log("onDependencyInserted", event);

		let dependency = event.values as Dependency;

		if (Number.isNaN(Number(dependency.id))) {
			dependency.id = -1;
		}

		if (Number.isNaN(Number(dependency.predecessorId))) {
			let task = this.tasks.find(task => task.taskId === dependency.predecessorId);

			if (task) {
				dependency.predecessorId = task.newIdToReplaceAutogeneratedGUID;
			} else {
				console.error("Couldn't find newly created task with such GUID.");
			}
		}

		if (Number.isNaN(Number(dependency.successorId))) {
			let task = this.tasks.find(task => task.taskId === dependency.successorId);

			if (task) {
				dependency.successorId = task.newIdToReplaceAutogeneratedGUID;
			} else {
				console.error("Couldn't find newly created task with such GUID.");
			}
		}

		const $this = this;

		this.projectService.insertDependency(dependency).subscribe();
	}

	public onResourceUnassigned(event: any) {
		console.log("onResourceUnassigned", event);


	}

	public onResourceAssigned(event: any) {
		console.log("onResourceAssigned", event);

		let resourceAssignment = event.values as ResourceAssignment;

		let task: Task = this.tasks.find((innerTask) => innerTask.taskId === resourceAssignment.taskId);

		if (task.newIdToReplaceAutogeneratedGUID > 0) {
			resourceAssignment.taskId = task.newIdToReplaceAutogeneratedGUID;
		}

		const $this = this;

		this.projectService.assignResource(resourceAssignment).subscribe();
	}

	private resourcesToBeDeleted: Resource[] = [];

	public onResourceDeleted(event: any) {
		console.log("onResourceDeleted", event);

		let resource: Resource = this.resourcesToBeDeleted.find((innerResource) => innerResource.id === event.key);

		if (resource.newId > 0) {
			resource.id = resource.newId;
		}

		const $this = this;

		this.projectService.deleteResource(resource).subscribe();
	}

	public onResourceDeleting(event: any) {
		console.log("onResourceDeleting", event);

		let resource: Resource = this.resources.find((innerResource) => innerResource.id === event.key);

		this.resourcesToBeDeleted.push(resource);
	}

	public onResourceInserted(event: any) {
		console.log("onResourceInserted", event);

		let resource = event.values as Resource;

		let insertedResourceIndex: number = this.resources.findIndex((innerResource) => innerResource.id === event.key);

		const $this = this;

		this.projectService.insertResource(resource).subscribe(
			(response) => {
				if (response.success) {


					$this.resources[insertedResourceIndex].newId = response.id;
				}
			}
		);
	}

	private tasksToBeDeleted: Task[] = [];

	public onTaskDeleted(event: any) {
		console.log("onTaskDeleted", event);

		let task: Task = this.tasksToBeDeleted.find((innerTask) => innerTask.taskId === event.key);

		if (task.newIdToReplaceAutogeneratedGUID > 0) {
			task.taskId = task.newIdToReplaceAutogeneratedGUID;
		}

		let taskParentIndex: number = this.tasks.findIndex((innerTask) => innerTask.taskId === task.parentTaskId);

		if (taskParentIndex >= 0 && this.tasks[taskParentIndex].newIdToReplaceAutogeneratedGUID > 0) {
			task.parentTaskId = this.tasks[taskParentIndex].newIdToReplaceAutogeneratedGUID;
		} else if (Number.isNaN(Number(task.parentTaskId))) {
			task.parentTaskId = 0;
		}

		const $this = this;

		this.taskService.deleteTask(task).subscribe();
	}

	public onTaskDeleting(event: any) {
		console.log("onTaskDeleting", event);

		let task: Task = this.tasks.find((innerTask) => innerTask.taskId === event.key);

		this.tasksToBeDeleted.push(task);
	}

	public onTaskInserted(event: any) {
		console.log("onTaskInserted", event);

		let task: Task = event.values as Task;

		let insertedTaskIndex: number = this.tasks.findIndex((innerTask) => innerTask.taskId === event.key);
		let insertedTaskParentIndex: number = this.tasks.findIndex((innerTask) => innerTask.taskId === task.parentTaskId);



		if (insertedTaskParentIndex < 0) {
			this.tasks[insertedTaskIndex].parentTaskId = 0;
			task.parentTaskId = 0;
		} else {
			if (Number.isNaN(Number(this.tasks[insertedTaskIndex].parentTaskId))) {


				task.parentTaskId = this.tasks[insertedTaskParentIndex].newIdToReplaceAutogeneratedGUID;
			}

			let parentTaskResourceAssigmentIndex = this.resourceAssignments.findIndex((resourceAssigment) => resourceAssigment.taskId === this.tasks[insertedTaskParentIndex].taskId);

			if (parentTaskResourceAssigmentIndex >= 0) {
				this.resourceAssignments.splice(parentTaskResourceAssigmentIndex, 1); // Remove responsible user from parent task.
			}
		}

		this.tasks[insertedTaskIndex].link = this.location.path();
		task.link = this.tasks[insertedTaskIndex].link;

		this.tasks[insertedTaskIndex].progress = 0;
		task.progress = 0;

		if (this.selectedProjectId) {
			this.tasks[insertedTaskIndex].projectId = this.selectedProjectId;
			task.projectId = this.selectedProjectId;
		} else {
			this.tasks[insertedTaskIndex].projectId = 0;
			task.projectId = 0;
		}

		this.tasks[insertedTaskIndex].responsibleUser = this.authService.currentUserName;
		task.responsibleUser = this.authService.currentUserName;

		const $this = this;

		this.taskService.createNewTask(task).subscribe(
			(response) => {
				if (response.success) {
					$this.tasks[insertedTaskIndex].newIdToReplaceAutogeneratedGUID = response.id;


					$this.assignResourceToTask($this.tasks[insertedTaskIndex]);

					$this.refreshGanttChart();

					$this.resourceAssignments = [...this.resourceAssignments];
				}
			}
		);
	}

	public onTaskUpdated(event: any) {
		console.log("onTaskUpdated", event);

		let task: Task = Object.assign(new Task(), this.tasks.find((innerTask) => innerTask.taskId === event.key), event.values);

		if (task.newIdToReplaceAutogeneratedGUID > 0) {
			task.taskId = task.newIdToReplaceAutogeneratedGUID;
		}

		let taskParentIndex: number = this.tasks.findIndex((innerTask) => innerTask.taskId === task.parentTaskId);

		if (taskParentIndex >= 0 && this.tasks[taskParentIndex].newIdToReplaceAutogeneratedGUID > 0) {
			task.parentTaskId = this.tasks[taskParentIndex].newIdToReplaceAutogeneratedGUID;
		}

		const $this = this;

		this.taskService.updateTask(task).subscribe(
			(response) => {
				$this.projectsToTasksChange.emit();
			}
		);
	}

	public taskPopupOnSubmitted(event: any) {
		console.log("taskPopupOnSubmitted - event:", event);

		let task: Task = event as Task;



		let chartTaskIndex: number = this.tasks.findIndex(innerTask => innerTask.taskId === task.taskId);

		// Assigning because method copyFrom would be missing otherwise.
		let chartTask: Task = Object.assign(new Task(), this.tasks[chartTaskIndex]);

		if (chartTask) {


			chartTask.copyFromTask(task);

			this.tasks[chartTaskIndex] = chartTask;

			this.updateResourceAssignmentOfTask(this.tasks[chartTaskIndex]);

			this.refreshGanttChart();
		} else {
			console.error("Couldn't find a task with this id. Tasks:", this.tasks);
		}
	}

	public customizeProgressText(cellInfo: any) {
		return cellInfo.value + "%";
	}

	constructor(
		private projectService: ProjectService,
		private taskService: TaskService,
		private authService: AuthService,
		private location: Location,

		private notificationService: NotificationService,
	) { }

	ngOnInit() {
	}
}
